import styled from "@emotion/styled";

import { Box } from "@/components/layout/flexbox";
import { breakpoints } from "@/components/layout/Media";
import { INNER_BORDER_COLOR } from "@/css/constants";

export const TimeslotList = styled(Box)`
  &.timeslot-grid {
    width: 100%;

    &.timeslot-horizontal {
      .timeslots-selector {
        .timeslot-item {
          flex: 1 24%;
          margin-right: 1%;
          max-width: 24%;
        }
      }
    }

    .timeslots-selector {
      width: 100%;
      display: flex;
      flex-wrap: wrap;

      .timeslot-item {
        flex: 1 30.3%;
        display: flex;
        margin-right: 1%;
        max-width: 33.3%;

        @media screen and (max-width: ${breakpoints.lg - 1}px) {
          flex: 1 49%;
          max-width: 50%;
        }

        @media screen and (max-width: ${breakpoints.sm - 1}px) {
          flex: 1 30.3%;
          max-width: 33.3%;
        }
      }
    }
  }
`;

export const TimeZoneSelectorContainerStyled = styled(Box)`
  .select-time-range [class$="-control"] {
    border: 1px solid ${INNER_BORDER_COLOR} !important;
    background-color: #ffffff !important;
  }
`;
